import './index.scss';

(function ($, Drupal, drupalSettings) {
  drupalSettings.viewports = drupalSettings.viewports || {
        'toSmallMobile': [0, 576, 'is-mobile is-small-mobile'],
        'toMobile': [577, 1080, 'is-mobile'],
        'toWeb': [1080, 1111111, 'is-web']
      };
  require('responsive');
  const { init } = require('slick');
  const json = require('./slick.config.json');
  init(json);

  //
  //  drupalSettings.element_css_variables = ['header#header'];
  //  require('element_css_variables');
})(jQuery, Drupal, drupalSettings);
